import Vue from 'vue'
import Vuex from 'vuex'
import Users from './users'
import Food from './food'
import Notifications from './notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Food,
    Users,
    Notifications
  }
})
